import {AvailableDocumentTypes} from 'types/documents';
import {Document} from '../../services';

export const isDocumentType = (document: Document) =>
    AvailableDocumentTypes.includes(document.documentType);

export default {};
